import React from 'react';
import Container from '../../Basic/Container/Container.mjs';
import DesktopOnly from '../../Containers/DesktopOnly/DesktopOnly.mjs';
import StoryInfo from '../StoryInfo/StoryInfo.mjs';
import { StyledMediaCardContainer, StyledMediaCardDuration, StyledMediaCardImageContainer, StyledMediaCardImage, StyledMediaCardHeading } from './MediaCard.styles.mjs';
import { useTheme } from 'styled-components';

const MediaCard = ({ durationTime, thumbnail, heading, fullWidth = false, inverseTextColor, storyInfo, href, fullFlex, onClick, isLarge, className = '' }) => {
    const theme = useTheme();
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledMediaCardContainer, { className: `${className} minute-card ${isLarge ? 'minute-card-large' : ''}`, fullWidth: fullWidth, href: href, fullFlex: fullFlex, isLarge: isLarge, onClick: onClick },
            Boolean(durationTime) && (React.createElement(StyledMediaCardDuration, { className: "minute-card-duration", durationTime: durationTime })),
            React.createElement(StyledMediaCardImageContainer, { className: "minute-card-image-container" },
                React.createElement(StyledMediaCardImage, { alt: thumbnail.alt, className: "minute-card-image", src: thumbnail.src })),
            React.createElement(StyledMediaCardHeading, { inverseTextColor: inverseTextColor, tag: "h4" }, heading)),
        isLarge && storyInfo && (React.createElement(DesktopOnly, { breakpoint: theme.breakpoints.md },
            React.createElement(Container, { fullWidth: true, padding: "0.6rem 0 0" },
                React.createElement(StoryInfo, { authors: storyInfo.authors, date: storyInfo.date, updatedAt: storyInfo.updatedAt }))))));
};

export { MediaCard as default };
//# sourceMappingURL=MediaCard.mjs.map
